import { CircleUserRound } from "lucide-react";
import type { KeyValueItem } from "@repo/types/ui/keyValuePairs";
import type { RecordId } from "@repo/types/ui/tables";
import TruncatedText from "../../ui/TruncatedText";
import BlobImage from "../../ui/image/BlobImage";

export function getKeyValueMenuButtonRenderer(
  items: KeyValueItem[],
  currentKey: RecordId,
) {
  const currentItem = items?.find((la) => la.Id === currentKey);
  return (
    <div
      className="flex items-center justify-center cursor-pointer w-full h-full"
      style={{
        backgroundColor: currentItem?.BgColorHex ?? "#999",
        color: currentItem?.TextColorHex ?? "#000",
      }}
    >
      {currentItem ? (
        <TruncatedText text={currentItem.Value} maxLength={15} />
      ) : (
        "Unknown"
      )}
    </div>
  );
}

export function getUserMenuButtonRenderer(
  items: KeyValueItem[],
  currentKey: RecordId,
) {
  const currentAssignee = items.find((la) => la.Id === currentKey);

  return (
    <div className="text-sm w-full h-full flex items-center justify-center cursor-pointer">
      <div className="flex items-center gap-x-2">
        <div className="w-7 h-8 flex items-center justify-center">
          <BlobImage
            src={currentAssignee?.image}
            className="w-6 h-6 rounded-full object-cover"
            fallback={
              <CircleUserRound size={25} className="font-normal opacity-30" />
            }
          />
        </div>
      </div>
    </div>
  );
}
